import {
  Ruler, BedDouble, Sofa, CookingPot, Bath, Sun, Flower2, Flame,
  SquareParking, Footprints, MapPin, Waves,
} from "lucide-react";

const photos = (folder, list) =>
  list.map(([nr, caption]) => ({
    id: `${folder}-${nr}`,
    src: `/images/${folder}/${folder}-${nr}.webp`,
    thumb: `/images/${folder}/${folder}-${nr}-thumb.webp`,
    caption,
  }));

const bookingBase = (slug) => ({
  sv: `https://www.booking.com/hotel/se/${slug}.sv.html`,
  en: `https://www.booking.com/hotel/se/${slug}.en-gb.html`,
  de: `https://www.booking.com/hotel/se/${slug}.de.html`,
});

export const COTTAGES = [
  {
    key: "karlstugan",
    name: "Karlstugan Cottage",
    address: "Solnehult 171, 598 91 Vimmerby",
    booking: bookingBase("solnehult-gamlegay-rd"),
    icons: [Ruler, BedDouble, Sofa, CookingPot, Bath, Sun, Flower2, Flame, SquareParking, Footprints, MapPin],
    photos: photos("karlstugan", [
      ["01", "frontFurniture"], ["05", "houseGarden"], ["14", "gardenSide"], ["07", "living"],
      ["10", "livingCorner"], ["22", "dining"], ["17", "kitchen"], ["19", "kitchenNook"],
      ["20", "living"], ["02", "bedroom"], ["06", "bedroom"], ["12", "bedroom"],
      ["03", "bathroom"], ["04", "veranda"], ["15", "verandaView"], ["25", "roses"],
      ["27", "inGarden"], ["13", "surroundings"],
    ]),
  },
  {
    key: "bjorkslingan",
    name: "Björkslingan",
    address: "Björkslingan 12, 598 91 Vimmerby",
    booking: bookingBase("bjorkslingan"),
    icons: [Ruler, BedDouble, Bath, Sofa, CookingPot, Sun, Flame, SquareParking, Waves, MapPin],
    photos: photos("bjorkslingan", [
      ["05", "front"], ["08", "underBirches"], ["13", "houseFurniture"], ["01", "bigBirch"],
      ["14", "garden"], ["15", "pergola"], ["16", "terrace"], ["21", "living"],
      ["22", "living"], ["11", "livingCorner"], ["04", "kitchen"], ["12", "kitchen"],
      ["18", "diningArea"], ["02", "bedroom"], ["06", "bathroom"], ["23", "bathroom"],
      ["09", "gardenSeating"], ["10", "woodsSeating"],
    ]),
  },
];

export const DESTINATIONS = [
  { key: "alv", url: "https://astridlindgrensvarld.se/information/hitta-hit/", host: "astridlindgrensvarld.se" },
  { key: "nas", url: "https://astridlindgrensnas.se/information/hitta-hit/", host: "astridlindgrensnas.se" },
  { key: "filmbyn", url: "https://www.vimmerby.com/se-gora/filmbyn-smaland/", host: "vimmerby.com" },
  { key: "fishing", url: "https://www.vimmerby.com/se-gora/fiska-i-vimmerby-kommun/", host: "vimmerby.com" },
  { key: "tourist", url: "https://www.vimmerby.com/se-gora/", host: "vimmerby.com" },
];

export const SECTIONS = [
  { id: "hem", key: "home" },
  { id: "stugor", key: "cottages" },
  { id: "om-oss", key: "about" },
  { id: "aktiviteter", key: "activities" },
  { id: "kontakt", key: "contact" },
];
